import WebLayout from './EventFieldLayout.web';
import MobileLayout from './EventFieldLayout.mobile';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
